var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FancyDropdown',{attrs:{"icon":"sliders","options":_vm.options,"current-value":_vm.currentValue,"content-classes":"max-h-[12rem]","selection-text":_vm.$t('Sort by {selection}')},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }